import type { Quote } from "@/lib/types";
import { fmtPrice } from "@/lib/format";

/** Top of the order book: best bid (köp) and best ask (sälj) + spread. */
export function BidAsk({ quote }: { quote: Quote | null }) {
  if (!quote || quote.bid == null || quote.ask == null) return null;
  return (
    <div className="flex items-stretch gap-2 text-sm">
      <div className="rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-3 py-1.5">
        <div className="text-[10px] uppercase tracking-wide text-emerald-500/80">Köp</div>
        <div className="font-semibold tabular-nums text-emerald-500">{fmtPrice(quote.bid)}</div>
      </div>
      <div className="rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-1.5">
        <div className="text-[10px] uppercase tracking-wide text-red-500/80">Sälj</div>
        <div className="font-semibold tabular-nums text-red-500">{fmtPrice(quote.ask)}</div>
      </div>
      {quote.spreadPct != null && (
        <div className="rounded-lg border border-border px-3 py-1.5">
          <div className="text-[10px] uppercase tracking-wide text-muted-foreground">Spread</div>
          <div className="font-semibold tabular-nums">{quote.spreadPct.toFixed(2)} %</div>
        </div>
      )}
    </div>
  );
}
